import React, { useEffect, useState, useCallback } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { Card } from 'react-bootstrap'
import { Loading } from '@rd-web-markets/shared/dist/util';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import technicalUploadsService from '@services/claim/technical_uploads_service';
import AbstractClaimGroupChildPage from '@rd-web-markets/shared/dist/pages/abstract/AbstractClaimGroupChildPage';
import FolderAndFileManagement from '@rd-web-markets/shared/dist/folders_and_files/FolderAndFileManagement';
import { useFileManagementUrlHandler } from '@rd-web-markets/shared/dist/hooks/useFileManagementUrlHandler';
import { useSelector } from 'react-redux';

const TechnicalUploadsPage = AbstractClaimGroupChildPage({
  highlightedMenuItem: 'technical_uploads',
  ClaimGroupChildPage: function ({
    accountType,
    claimGroup,
    t
}) {
  const { claimGroupId } = useParams();
  const history = useHistory();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const userClaimGroupAbilities = window.MARKET_SETUP.useGetUserClaimGroupAbilities({ user, claimGroup });
  const [uploads, setUploads] = useState(null);
  const modelQuery = `?${new URLSearchParams({
    key: 'documents',
    model_type: 'ClaimGroup',
    model_name: claimGroup.name,
    model_id: claimGroup.id,
    folder: claimGroup.client_uploads_folder.id
  }).toString()}`;

  const [ key, goToTab, goToFolderQuery, fileUploaderUsers, modelName, modelType, modelId, getFileUploadersAndVirtualFolderPath ] = useFileManagementUrlHandler({
    urlKey: 'claim_group_client_documents',
    modelQuery
  });

  const fetchUploads = useErrorHandling(useCallback(async () => {
    const uploads = await technicalUploadsService.all(claimGroupId);
    setUploads(uploads);
  }, [claimGroupId]))

  useEffect(() => {
    fetchUploads();
  }, [fetchUploads]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const currentModelType = searchParams.get('model_type');
    const currentModelId = searchParams.get('model_id');
    const currentModelName = searchParams.get('model_name');

    if (currentModelType !== 'ClaimGroup' || currentModelId !== claimGroup.id.toString() || currentModelName !== claimGroup.name) {
      history.replace({
        search: modelQuery
      });
    }
  }, [claimGroup.id, history, location.search, modelQuery]);

  if(!claimGroup || !uploads) return <Loading />;

  return (
    <>
      <div style={{ paddingTop: '1.5rem' }}>
        <div className="ps-4 pe-4">
          <h1 className='text-primary mb-5'>{t('upload_document')}</h1>

          <Card>
            <Card.Body>
              <FolderAndFileManagement
                canEditExistingDocumentsOrFolders={true}
                targetModelId={claimGroup.id}
                type={'ClaimGroup'}
                modelName={modelName}
                goToFolderQuery={goToFolderQuery}
                fileUploaderUsers={fileUploaderUsers}
                getFileUploadersAndVirtualFolderPath={getFileUploadersAndVirtualFolderPath}
                rootFolderId={claimGroup.client_uploads_folder.id}
                userClaimGroupAbilities={userClaimGroupAbilities}
              />
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  )
  }
})
export default TechnicalUploadsPage
